import httpReq from '@/server/zqhttp';
import { systemType } from '@/utils/utils';

const zqhttpRequest = {
  // **************************分享页 start****************
  // 获取助眠数据
  getSleepHelp: function(params) {
    var url = '/sleep-help';
    return httpReq(url, 'get', params);
  },
  getTopic: function(params) {
    var url = '/topic-share';
    return httpReq(url, 'get', params);
  },
  getCourse: function(params) {
    var url = `/m/course/show/${params.id}`;
    return httpReq(url, 'get');
  },
  getSection: function(params) {
    var url = `/m/course/section/${params.id}`;
    return httpReq(url, 'get');
  },
  getVideo: function(params) {
    var url = `/m/videos/${params.id}`;
    return httpReq(url, 'get');
  },
  getArticle: function(params) {
    var url = `/m/articles/${params.id}`;
    return httpReq(url, 'get');
  },
  updateDownloadCount: function(params) {
    var url = '/channel-download';
    return httpReq(url, 'post', params);
  },
  getArticle: function(params) {
    var url = `/m/articles/${params.id}`;
    return httpReq(url, 'get');
  },
  getDoc: function(keyword='', page=1) {
    var url = `/m/doc-search?keyword=${keyword}&page=${page}`
    return httpReq(url, 'get');
  },
  // 获取课程分类列表
  getCourseCategoryList: function (params) {
    var url = '/m/categories';

    return httpReq(url, 'get', params);
  },
  // 获取课程列表
  getCourseList: function (params) {
    var url = '/m/course/index';

    return httpReq(url, 'get', params);
  },
  // 获取精选课程列表
  getRecommendCourseList: function (params) {
    var url = '/m/course/recommend-list';

    return httpReq(url, 'get', params);
  },
  // 获取课程推荐页数据
  getCourseRecommend: function () {
    var url = '/m/course/recommend';

    return httpReq(url, 'get');
  },
}

export default zqhttpRequest



// WEBPACK FOOTER //
// ./src/server/zqhttp-api.js